@if (initialized && customerId) {
  <overview-component [customerId]="customerId"></overview-component>
}
